import MainIcons from '@/icons/main';
import styles from './styles.module.css';
import { cloneElement, isValidElement, useEffect, useState } from 'react';
import AppLink from '@/components/common/AppLink';
import LogoSection from '../Toolbar/LogoSection';
import { useLocale } from 'next-intl';
import { ServiceSubCategory } from '@/commonTypes';

export default function Footer({
  footerSubCategory,
}: {
  footerSubCategory?: ServiceSubCategory[];
}) {
  const [year, setYear] = useState<string>();
  const locale = useLocale();

  useEffect(() => {
    setYear(
      new Date()
        .toLocaleString(locale, {
          year: 'numeric',
        })
        .split(',')[0],
    );
  }, [locale]);
  const footer = {
    about:
      'کارا یک پلتفرم خدمات دیجیتال خودرو است که به شما امکان می‌دهد بدون مراجعه حضوری و تنها با وارد کردن پلاک، اطلاعات خودروی خود را مشاهده و مدیریت کنید. از خلافی و گواهینامه تا وضعیت پلاک‌ها و یادآوری تمدید بیمه و معاینه فنی – همه با دقت و سرعت بالا.',
    copy: `© ${year} کارا — تمامی حقوق محفوظ است.`,
    made: 'ساخته‌شده با هوش مصنوعی کارا',
    social: [
      { icon: <MainIcons.ChatIcon /> },
      { icon: <MainIcons.notifIcon /> },
      { icon: <MainIcons.BellIcon /> },
    ],
    cols: [
      {
        title: 'خدمات',
        // links: [
        //   { title: 'خلافی خودرو', href: '/traffic-fines' },
        //   { title: 'بیمهٔ شخص ثالث', href: '/third-party-insurance' },
        //   { title: 'معاینهٔ فنی', href: '/technical-inspection' },
        //   { title: 'معاملهٔ خودرو', href: '/car-trading' },
        // ],
        links: footerSubCategory?.map((item) => {
          return { ...item, href: `/service/${item?.slug}` };
        }),
      },
      {
        title: 'شرکت',
        links: [
          { title: 'درباره ما', href: '/about' },
          { title: 'بلاگ', href: '/blogs' },
          { title: 'فرصت‌های شغلی', href: '/careers' },
          { title: 'تماس با ما', href: '/contactUs' },
        ],
      },
      {
        title: 'پشتیبانی',
        links: [
          { title: 'پرسش و پاسخ', href: '/faq' },
          { title: 'راهنما', href: '/help' },
          { title: 'حریم خصوصی', href: '/privacy' },
          { title: 'قوانین', href: '/terms' },
        ],
      },
    ],
  };
  const nav = {
    tagline: 'سامانه جامع خودرو',
    langLabel: 'EN',
    login: 'ورود',
    signup: 'ثبت‌نام',
    links: [{ label: 'خدمات' }, { label: 'برند' }, { label: 'بلاگ' }, { label: 'درباره ما' }],
  };
  return (
    <footer className={styles.footer}>
      <div className={` ${styles.grid} container`}>
        <div>
          <div className={styles.brand}>
            <LogoSection />
          </div>
          <p className={styles.about}>{footer.about}</p>
          <div className={styles.social}>
            {footer.social.map((so, i) => (
              <AppLink key={i} href="#" className={styles.socialLink}>
                {isValidElement(so?.icon as React.ReactElement<React.SVGProps<SVGSVGElement>>)
                  ? cloneElement(so?.icon, {
                      fill: '#fff',
                      width: `${'17px'}`,
                      height: `${'17px'}`,
                    })
                  : so?.icon}
              </AppLink>
            ))}
          </div>
        </div>

        {footer?.cols.map((col) => (
          <div key={col.title}>
            <h4 className={styles.colTitle}>{col.title}</h4>
            {col?.links?.map((fl, index) => (
              <AppLink key={index} href={fl?.href} className={styles.colLink}>
                {fl?.title}
              </AppLink>
            ))}
          </div>
        ))}
      </div>

      <div className={`container ${styles.bar}`}>
        <span className={styles.barText}>{footer.copy}</span>
        {/* <span className={styles.barText}>{footer.made}</span> */}
      </div>
    </footer>
  );
}
